import { useEffect, useState } from "react";

/* Atrasa a propagação de um valor até ele parar de mudar.

   Existe por causa da busca de escolas, que filtra NO SERVIDOR: a lista é
   paginada (100 de até 990), então o termo entra na chamada. Sem atraso, cada
   tecla dispararia uma requisição — "municipal" são dez, das quais nove viram
   resposta descartada, e a última a chegar não é necessariamente a da letra mais
   recente (as respostas voltam fora de ordem).

   Nas listas que filtram no cliente isto não é necessário e nem deve ser usado:
   lá o filtro é síncrono e o atraso só faria a tela parecer travada.

   Não usei nenhuma biblioteca de debounce porque o deploy do Backend é FTP puro
   e o do Frontend é build estático — dependência nova é custo desproporcional
   para doze linhas. */
export function useDebounce(valor, ms = 300) {
  const [atrasado, setAtrasado] = useState(valor);

  useEffect(() => {
    const id = setTimeout(() => setAtrasado(valor), ms);
    // Limpar no cleanup é o que faz o atraso ser "só quando parar de digitar":
    // cada tecla nova cancela o timer da anterior.
    return () => clearTimeout(id);
  }, [valor, ms]);

  return atrasado;
}
